import { BoardFloorInterface } from '../interfaces/board-floor.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';

import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

import { IsNumber, IsUUID, Max, Min } from 'class-validator';

import { Exclude, Expose } from 'class-transformer';

import {
  BOARD_FLOOR_FLOOR_MIN,
  BOARD_FLOOR_FLOOR_MAX,
  BOARD_FLOOR_QUANTITY_MIN,
  BOARD_FLOOR_QUANTITY_MAX,
} from '../constants/board-floor-validation.constants';
import { BoardTypeDto } from '../../board-type/dtos/board-type.dto';
import { BoardPurchaseDto } from '../../board-purchase/dto/board-purchase.dto';

@Exclude()
export class BoardFloorDto
  extends CommonEntityDto
  implements BoardFloorInterface
{
  @ApiProperty({
    title: 'Floor Number',
    description: 'The Floor Number',
    minimum: BOARD_FLOOR_FLOOR_MIN,
    maximum: BOARD_FLOOR_FLOOR_MAX,
  })
  @IsNumber()
  @Min(BOARD_FLOOR_FLOOR_MIN)
  @Max(BOARD_FLOOR_FLOOR_MAX)
  @Expose()
  floor!: number;

  @ApiProperty({
    title: 'Quantity',
    description: 'Quantity of board types for this floor',
    minimum: BOARD_FLOOR_QUANTITY_MIN,
    maximum: BOARD_FLOOR_QUANTITY_MAX,
  })
  @IsNumber()
  @Min(BOARD_FLOOR_QUANTITY_MIN)
  @Max(BOARD_FLOOR_QUANTITY_MAX)
  @Expose()
  quantity!: number;

  @ApiProperty({
    format: 'uuid',
    title: 'Board Type ID',
    description: 'The ID of the board type for this floor',
  })
  @IsUUID()
  @Expose()
  boardTypeId!: string;

  @ApiPropertyOptional({
    type: () => BoardTypeDto,
    title: 'Associated Board Type',
    description: 'The board type associated with this floor',
  })
  @Expose()
  boardType?: BoardTypeDto;

  @ApiProperty({
    format: 'uuid',
    title: 'Board Purchase ID',
    description: 'The ID of the board purchase',
  })
  @IsUUID()
  @Expose()
  boardPurchaseId!: string;

  @ApiPropertyOptional({
    type: () => BoardPurchaseDto,
    title: 'Associated Board Purchase',
    description: 'The board purchase associated with this floor',
  })
  @Expose()
  boardPurchase?: BoardPurchaseDto;
}
